/**
 * @page 计价单位切换 store
 * @author
 * @Date 2018/9/11
 */

import {
  observable,
  action,
  configure,
  computed,
  makeAutoObservable,
} from 'mobx';

import valueUnitService from '_common/service/valueUnitService';

configure({
  enforceActions: 'always',
});

export default class valuationUnitStore {
  constructor(rootStore) {
    makeAutoObservable(this, {
      valuationUnit: observable,
      valuationItems: observable,
      gotUnit: observable,
      fetching: observable,
      smallAmount: observable,
      smallAmountText: computed,
      selectValuation: action,
      getValuationUnit: action,
    });

    this.rootStore = rootStore;
  }

  // 计价单位
  valuationUnit = localStorage.getItem('valuationUnit') || 'JPY';
  valuationItems = [];

  gotUnit = false; // 是否已经获取过
  fetching = false; // 是否正在获取

  // 对应计价隐藏小额的标准
  smallAmount = '';

  get smallAmountText() {
    return [this.smallAmount, this.valuationUnit].join('');
  }

  // 切换计价
  selectValuation(valuationUnit, smallAmount) {
    this.valuationUnit = valuationUnit;
    this.smallAmount = smallAmount;
    localStorage.setItem('valuationUnit', valuationUnit);
  }

  /**
   * 获取计价单位
   */
  getValuationUnit() {
    this.fetching = true;
    valueUnitService
      .getValueUnit()
      .then(
        action((res) => {
          // 处理一下资产格式
          const valuationItems = [];
          res.data.list &&
            res.data.list.forEach((item) => {
              const params = {
                label: item.name,
                value: item.smallAmount,
              };
              valuationItems.push(params);
              if (item.name === this.valuationUnit) {
                this.smallAmount = item.smallAmount;
              }
            });
          this.valuationItems = valuationItems;
          this.gotUnit = true;
          this.fetching = false;
        })
      )
      .catch(
        action(() => {
          this.fetching = false;
        })
      );
  }
}
